var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useReducer, useState } from 'react';
import { analytics, useLocale } from "../../communication";
import Scheduler from "../SharedScheduler/components/Scheduler";
import { MessageContext } from "../../hooks/MessageContext";
import { OrderContext } from "../../hooks/OrderContext";
import { SchedulerDataContext } from "../../hooks/SchedulerDataContext";
import { StepContext } from "../../hooks/StepContext";
import { getAvailability, patchOrder, trackingEvents, TRACKING_NAMESPACE, } from "../../services/schedulerService";
import useLoader from "../../hooks/useLoader";
import StepButtons from "../StepButtons/StepButtons";
import { formatPreferredStartTime, formatSlot, setLanguage } from "./Scheduler.utils";
function dateReducer(state, action) {
    var result = new Date(action.times[0].date);
    if (action.direction === "forward") {
        result.setDate(result.getDate() + action.step);
    }
    else {
        result.setDate(result.getDate() - action.step);
        var today = new Date();
        // Never go further back than today
        if (today.getTime() > result.getTime()) {
            return today;
        }
    }
    return result;
}
function getSlot(schedulerData, timezone) {
    if (schedulerData.scheduler) {
        return formatSlot(schedulerData.scheduler.preferred_start_time, timezone, schedulerData.scheduler);
    }
    return {};
}
export default function SchedulerWrapper() {
    var _a, _b, _c;
    var _d = useLoader(), isLoading = _d.isLoading, startLoader = _d.startLoader, stopLoader = _d.stopLoader;
    var language = useLocale().language;
    var _e = useContext(OrderContext), order = _e.order, setOrder = _e.setOrder;
    var setMessage = useContext(MessageContext).setMessage;
    var _f = useContext(SchedulerDataContext), schedulerData = _f.schedulerData, setSchedulerData = _f.setSchedulerData;
    var next = useContext(StepContext).next;
    var timezone = (_a = order === null || order === void 0 ? void 0 : order.address) === null || _a === void 0 ? void 0 : _a.property_time_zone;
    var _g = useState(getSlot(schedulerData, timezone)), selectedSlot = _g[0], setSelectedSlot = _g[1];
    var _h = useState(((_b = schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData.scheduler) === null || _b === void 0 ? void 0 : _b.earliestPossibleDate) || null), earliestPossibleDate = _h[0], setEarliestPossibleDate = _h[1];
    var _j = useState(null), selectedDate = _j[0], setSelectedDate = _j[1];
    var _k = useReducer(dateReducer, ((_c = schedulerData === null || schedulerData === void 0 ? void 0 : schedulerData.scheduler) === null || _c === void 0 ? void 0 : _c.preferred_start_time) || new Date()), date = _k[0], setDate = _k[1];
    useEffect(function () {
        getAvailability(date.toISOString()).then(function (_a) {
            var data = _a.data;
            setSelectedDate(data);
            stopLoader();
        });
    }, [date]);
    useEffect(function () {
        startLoader();
    }, []);
    useEffect(function () {
        setLanguage(language);
    }, [language]);
    useEffect(function () {
        if (selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.formattedDateTime) {
            analytics.track(TRACKING_NAMESPACE, trackingEvents.APPOINTMENT_SELECTED, {
                selected_time: selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.formattedDateTime,
            });
        }
    }, [selectedSlot]);
    var isValid = function () { return selectedSlot.datetime; };
    if (!selectedDate) {
        return null;
    }
    if (isLoading) {
        return null;
    }
    var handleSubmit = function (e) {
        e.preventDefault();
        var patchData = {
            preferred_start_time: selectedSlot.datetime,
        };
        patchOrder(patchData, "schedule")
            .then(function (data) {
            setOrder(data);
            setSchedulerData({
                step: "scheduler",
                data: __assign(__assign(__assign({}, selectedSlot), patchData), { formatted: formatPreferredStartTime(selectedSlot.datetime, timezone), earliestPossibleDate: earliestPossibleDate }),
            });
        })
            .then(next)
            .catch(function (error) {
            var _a, _b;
            setMessage((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message);
        });
    };
    return (_jsxs("form", __assign({ onSubmit: handleSubmit, className: "mp-scheduler-wrapper" }, { children: [_jsx(Scheduler, { dates: selectedDate, earliestPossibleDate: earliestPossibleDate, handleDateChange: setDate, order: order, selectedSlot: selectedSlot, setSelectedSlot: setSelectedSlot, setEarliestPossibleDate: setEarliestPossibleDate }), _jsx(StepButtons, { valid: isValid })] })));
}
